export default __webpack_public_path__ + "8ee8e9f52146e12525f2fcf5cd346018.png";